<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.settings') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.settings') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <el-form ref="form" :model="formData" size="large" :rules="formRules">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4>{{ $t('settings.title1') }}</h4>
            </div>
            <div class="card-body">
              <el-tabs v-model="activeName">
                  <el-tab-pane :label="$t('settings.general')" name="1">
                    <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item :label="$t('settings.lang')">
                        <el-switch
                          v-model="formData.lang"
                          :active-text="$t('settings.en')"
                          :inactive-text="$t('settings.zh')"
                          style="width:100%">
                        </el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      {{ $t('settings.notice.title') }}
                      <hr>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      {{ $t('settings.notice.offer') }}
                    </el-col>
                    <el-col :span="18">
                      <el-switch
                        v-model="formData.offer">
                      </el-switch>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      {{ $t('settings.notice.cashin') }}
                    </el-col>
                    <el-col :span="18">
                      <el-switch
                        v-model="formData.cashin">
                      </el-switch>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      {{ $t('settings.notice.invoice') }}
                    </el-col>
                    <el-col :span="18">
                      <el-switch
                        v-model="formData.invoice">
                      </el-switch>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="6">
                      {{ $t('settings.notice.onboard') }}
                    </el-col>
                    <el-col :span="18">
                      <el-switch
                        v-model="formData.onboard">
                      </el-switch>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-checkbox v-model="formData.email">{{ $t('settings.notice.email') }}</el-checkbox>
                    </el-col>
                    <el-col :span="24">
                      <el-checkbox v-model="formData.sync">{{ $t('settings.notice.sync') }}</el-checkbox>
                    </el-col>
                  </el-row>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('settings.message')" name="2">
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.email.email-pass') }}
                    </el-col>
                      <el-col :span="12">
                      <el-input type="password" v-model="formData.emailPass" :placeholder="$t('login.password')" show-password></el-input>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
                      {{ $t('settings.email.allow-send') }}
                    </el-col>
                    <el-col :span="12">
                      <el-switch
                        v-model="formData.allowSend">
                      </el-switch>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
                      {{ $t('settings.email.allow-read') }}
                    </el-col>
                    <el-col :span="12">
                      <el-switch
                        v-model="formData.allowRead">
                      </el-switch>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
                      {{ $t('settings.email.allow-meeting') }}
                    </el-col>
                    <el-col :span="12">
                      <el-switch
                        v-model="formData.allowMeeting">
                      </el-switch>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
                      {{ $t('settings.email.keep-copy') }}
                    </el-col>
                    <el-col :span="12">
                      <el-switch
                        v-model="formData.keepCopy">
                      </el-switch>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.email.signature') }}
                    </el-col>
                    <el-col :span="18">
                      <quill-editor v-model="formData.signature" ref="myQuillEditor" class="editer" :options="editorOption" @ready="onEditorReady($event)"
                        >
                              </quill-editor>
                    </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('settings.about.about')" name="3">
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.about.version') }}
                    </el-col>
                    <el-col :span="18">
                      {{ this.VERSION }}
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.about.author') }}
                    </el-col>
                    <el-col :span="3">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73220" />
                      </div>
                      <h5 class="ct-title">
                        Steven CUI
                      </h5>
                    </el-col>
                    <el-col :span="15">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="19022" />
                      </div>
                      <h5 class="ct-title">
                        Flow JIANG
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.about.agreement') }}
                    </el-col>
                    <el-col :span="18">
                      <el-container style="height: 300px; border: 1px solid #eee">
                        <el-main>
                        <p>The system is owned by Element Resources Co., Ltd. ("ER"), whose registered office is at 1007, No.1788 West Nanjing Road, Jingan District, Shanghai.</p>
                        <p>These terms and conditions set out the basis on which you can visit and use our system. Please read them carefully as they contain important information. By using the system you are agreeing to be bound by these terms and conditions. ER reserves the right to vary these terms and conditions at any time and will post any variations accordingly. </p>
                        <p>Care and precaution are taken to ensure that information published on the system is accurate when posted and regularly updated, but ER does not guarantee the accuracy of the information contained in materials on the system and ER may change the information at any time without notice. The system is published without any warranty of any kind, express or implied, as to the operation of the system, the accuracy of the content or information, or the products or services referred to on the system (in so far as such warranties may be excluded by law). ER shall not be liable to any person for any loss or damage which may arise from the use of any information contained in any of the materials on this system or the use of this system.</p>
                        <p>The system pages, or parts thereof, containing share price information are published by Investis Limited on behalf of ER. ER does not vet nor have any control over this information and cannot accept any liability whatsoever in respect of this information.</p>
                        <p>The information contained on the system is not an invitation to invest in the shares, or any other products or services or otherwise deal in these or enter into a contract with ER or any other company. The information provided should not be relied upon in connection with any investment decision. This includes the number of jobs stated on the system.</p>
                        <p>The past performance of ER or any other company referred to on the system cannot be relied upon as a guide to its future performance. The price of shares and the income derived from them can go down as well as up and investors may not recoup the amount originally invested.</p>
                        <p>Any reference to any product or service which has been or may be provided by ER or any other company does not amount to a promise that such product or service will be available at any time. Changes to or improvements in such products or services may be made at any time without notice.</p>
                        <p>The release, publication or distribution of documents on the system in jurisdictions other than the United Kingdom may be restricted by law and, therefore, persons in a jurisdiction other than the United Kingdom into which such documents are released, published, distributed or otherwise accessible should inform themselves about and observe any such restrictions. Access to the system will not constitute an offer in jurisdictions in which it would be illegal to make such an offer and in such circumstances it will be deemed to have been sent for information purposes only.</p>
                        <p>All rights, including but not limited to intellectual property rights, are owned by or licensed to ER. Any use of this system or its content, including copying or storing it in whole or in part, other than for your personal, non-commercial use, is prohibited without the prior written permission of ER.</p>
                        <p>Content and information provided by third parties other than ER is identified clearly where it appears. ER publishes this content as supplied to ER and ER is not responsible for its accuracy or timeliness. You must take appropriate steps to verify this information before acting upon it.</p>
                        <p>ER is not responsible for the content of any other system from which you have accessed the system or to which you may hyperlink from the system and ER cannot be held liable for any loss or damage you incur as a result of your use of any other site from which you hyperlink to or from the system.</p>
                        <p>These terms and conditions of use are governed by the laws of England and Wales and you agree that the English courts shall have exclusive jurisdiction in any dispute.</p>
                        <p>To the extent that any part of these terms and conditions of use is found to be invalid, unlawful or unenforceable by any court of competent jurisdiction such part shall to that extent be severed from the remaining terms all of which shall remain in full force and effect as permitted by law.</p> 
                        </el-main>
                      </el-container>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.about.private') }}
                    </el-col>
                    <el-col :span="18">
                      <el-container style="height: 300px; border: 1px solid #eee">
                        <el-main>
                        <p>Element Resources is committed to protecting the privacy of its candidates, clients and other users of its system (“Element Resources Admin/Information Supporting System”). The Element Resources System Terms and Conditions are detailed in the System Terms and Conditions pages of the Element Resources System. For details of the Privacy Policy applicable to the jurisdiction from which you are accessing the Element Resources System, please click on the relevant link below. We want to provide a safe and secure user experience. We will ensure that the information you submit to us via the Element Resources System or through any of our offices is only used for the purposes set out in this policy.</p>

                        <h3>About Cookies</h3>
                        <p>When you visit our system, we use cookies, which are small pieces of information that allow us to maintain your connection to our system. This system may use cookies for detecting what kind of device you have in order to present content in the best way, for a language switch and/or for other purposes. These cookies do not collect or store any personally identifiable information. You can <a href="javascript:void(0)">refuse the use of cookies</a>.</p>

                        <h3>About Google Analytics</h3>
                        <p>This system uses Google Analytics, a web analytics service provided by Google, Inc. (‘Google’). Google Analytics uses cookies (text files placed on your computer) to help the system operators analyse how users use the site. The information generated by the cookie about your use of the system (including your IP address) will be transmitted to and stored by Google on servers in the United States. Google will use this information for the purpose of evaluating your use of the system, compiling reports on system activity for system operators and providing other services relating to system activity and internet usage. Google may also transfer this information to third parties where required to do so by law, or where such third parties process the information on Google's behalf. Google will not associate your IP address with any other data held by Google. By using this system, you consent to the processing of data about you by Google in the manner and for the purposes set out above.</p>

                        <h3>About Sharing tools</h3>
                        <p>This system uses sharing tools. Sharing tools allow you to share content through social networks such as WeChat, Weibo, QQ, Facebook or Twitter. When you use one of these buttons, the social networking site may place a cookie on your computer. This would be a third-party cookie set by the social networking site. If you have any questions about the use of these third-party cookies, you should check the relevant social networking site's cookie policy.</p>

                        <h3>How to refuse the use of cookies</h3>
                        <p>You may refuse the use of cookies by selecting the appropriate settings in your browser. However, if you do this you may lose some useful functionality such as personalisation and ‘keep me signed in’ and ‘remember me’ features.</p>
                        </el-main>
                      </el-container>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="24">
                      © Copyright 2014 - {{ info.year }} Element Resources. ALL Rights Reserved. 
                    </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('settings.log.title')" name="4">
                    <el-timeline>
                      <el-timeline-item timestamp="2021-08-20" placement="top">
                        <el-card>
                          <h4 style="color:red">Here will not list Git commit info any longer because unstable services, and we'll provide rigular change log monthly instead. Sorry for inconvenience and any suggestions please feel free to contact me <a href="mailto:flowjiang@element-resources.com" target="_blank">flowjiang@element-resources.com.</a></h4>
                          <p>Submitted by Flow Jiang @2021-08-20 09:00</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-05-24" placement="top">
                        <el-card>
                          <h4>Weekly review report updated</h4>
                          <p>Submitted by Flow Jiang @2021-05-24 14:32</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-05-24" placement="top">
                        <el-card>
                          <h4>BJ practice bug fixing</h4>
                          <p>Submitted by Flow Jiang @2021-05-24 10:32</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-05-18" placement="top">
                        <el-card>
                          <h4>Recur events support for meeting</h4>
                          <p>Submitted by Flow Jiang @2021-05-18 17:11</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-05-16" placement="top">
                        <el-card>
                          <h4>Messenger disconnect bug fixing</h4>
                          <p>Submitted by Flow Jiang @2021-05-16 12:19</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-26" placement="top">
                        <el-card>
                          <h4>Updated individual report</h4>
                          <p>Submitted by Flow Jiang @2021-04-26 11:05</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-23" placement="top">
                        <el-card>
                          <h4>New system compliance calc</h4>
                          <p>Submitted by Flow Jiang @2021-04-23 15:27</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-21" placement="top">
                        <el-card>
                          <h4>Contract filing directly</h4>
                          <p>Submitted by Flow Jiang @2021-04-21 11:11</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-15" placement="top">
                        <el-card>
                          <h4>monthly cost report</h4>
                          <p>Submitted by Flow Jiang @2021-04-15 19:22</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-12" placement="top">
                        <el-card>
                          <h4>Bonus calc for new debt rules</h4>
                          <p>Submitted by Flow Jiang @2021-04-12 22:09</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-07" placement="top">
                        <el-card>
                          <h4>Offer/invoice process - remove slogan</h4>
                          <p>Submitted by Flow Jiang @2021-04-07 21:00</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-06" placement="top">
                        <el-card>
                          <h4>Cost report by month</h4>
                          <p>Submitted by Flow Jiang @2021-04-06 11:19</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-04" placement="top">
                        <el-card>
                          <h4>ICS file subject & comment display</h4>
                          <p>Submitted by Flow Jiang @2021-04-04 23:54</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-04-01" placement="top">
                        <el-card>
                          <h4>Name Card change office</h4>
                          <p>Submitted by Flow Jiang @2021-04-01 14:00</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-23" placement="top">
                        <el-card>
                          <h4>Name Card for BJ office</h4>
                          <p>Submitted by Flow Jiang @2021-03-26 11:17</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-25" placement="top">
                        <el-card>
                          <h4>Partner individual report</h4>
                          <p>Submitted by Flow Jiang @2021-03-25 12:15</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-23" placement="top">
                        <el-card>
                          <h4>BD Call for KPI</h4>
                          <p>Submitted by Flow Jiang @2021-03-23 10:53</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-17" placement="top">
                        <el-card>
                          <h4>Weekly review report enhancement</h4>
                          <p>Submitted by Flow Jiang @2021-03-17 23:09</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-11" placement="top">
                        <el-card>
                          <h4>Weekly Review report - Cases Overview</h4>
                          <p>Submitted by Flow Jiang @2021-03-11 15:15</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-08" placement="top">
                        <el-card>
                          <h4>Weekly Review report</h4>
                          <p>Submitted by Flow Jiang @2021-03-08 15:29</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-05" placement="top">
                        <el-card>
                          <h4>C/E Report attachment bug fixing</h4>
                          <p>Submitted by Flow Jiang @2021-03-05 15:18</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-04" placement="top">
                        <el-card>
                          <h4>Contract review bug fixing</h4>
                          <p>Submitted by Flow Jiang @2021-03-04 22:09</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-03-01" placement="top">
                        <el-card>
                          <h4>Weekly review report dataset migrantion</h4>
                          <p>Submitted by Flow Jiang @2021-03-01 21:59</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-02-26" placement="top">
                        <el-card>
                          <h4>Probation remind</h4>
                          <p>Submitted by Flow Jiang @2021-02-26 11:31</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-02-22" placement="top">
                        <el-card>
                          <h4>BD /outbound credit</h4>
                          <p>Submitted by Flow Jiang @2021-02-22 20:00</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-02-20" placement="top">
                        <el-card>
                          <h4>New KPI framework</h4>
                          <p>Submitted by Flow Jiang @2021-02-20 14:01</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-02-17" placement="top">
                        <el-card>
                          <h4>Team transfer config</h4>
                          <p>Submitted by Flow Jiang @2021-02-17 11:11</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-02-11" placement="top">
                        <el-card>
                          <h4>Stimulation bug fixing for margin commission of P1</h4>
                          <p>Submitted by Flow Jiang @2021-02-11 11:11</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-01-28" placement="top">
                        <el-card>
                          <h4>Outbound offer/credit for practice reports</h4>
                          <p>Submitted by Flow Jiang @2021-01-28 10:23</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-01-27" placement="top">
                        <el-card>
                          <h4>BD Credit Rank</h4>
                          <p>Submitted by Flow Jiang @2021-01-27 13:40</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-01-22" placement="top">
                        <el-card>
                          <h4>Turnover rate for practice reports</h4>
                          <p>Submitted by Flow Jiang @2021-01-22 13:43</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-01-20" placement="top">
                        <el-card>
                          <h4>Fixed the bug of bonus calculation</h4>
                          <p>Submitted by Flow Jiang @2021-01-20 19:15</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-01-15" placement="top">
                        <el-card>
                          <h4>Learning adjustment of team simulator</h4>
                          <p>Submitted by Flow Jiang @2021-01-15 21:15</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2021-01-14" placement="top">
                        <el-card>
                          <h4>JWT auth of API</h4>
                          <p>Submitted by Flow Jiang @2021-01-14 11:20</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-12-18" placement="top">
                        <el-card>
                          <h4>Invoice value for reports</h4>
                          <p>Submitted by Flow Jiang @2020-12-18 14:22</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-12-16" placement="top">
                        <el-card>
                          <h4>Team configuartion and bug fixing</h4>
                          <p>Submitted by Flow Jiang @2020-12-16 22:48</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-12-14" placement="top">
                        <el-card>
                          <h4>Beijing as a practice</h4>
                          <p>Submitted by Steven Cui @2020-12-14 20:08</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-12-14" placement="top">
                        <el-card>
                          <h4>Task retransfer</h4>
                          <p>Submitted by Steven Cui @2020-12-14 21:10</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-12-10" placement="top">
                        <el-card>
                          <h4>Fixed the bug of contract review</h4>
                          <p>Submitted by Steven Cui @2020-12-10 11:10</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-12-01" placement="top">
                        <el-card>
                          <h4>Expected revenue and expected cost rate of sales cost rate report</h4>
                          <p>Submitted by Steven Cui @2020-12-01 12:10</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-30" placement="top">
                        <el-card>
                          <h4>Portfolio company option for offer creation</h4>
                          <p>Submitted by Flow Jiang @2020-11-30 14:06</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-27" placement="top">
                        <el-card>
                          <h4>Fixed bugs of connection pool which might cause deadlock</h4>
                          <p>Submitted by Flow Jiang @2020-11-27 23:55</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-24" placement="top">
                        <el-card>
                          <h4>Fixed bugs of account manager info</h4>
                          <p>Submitted by Flow Jiang @2020-11-24 21:18</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-20" placement="top">
                        <el-card>
                          <h4>User role front-end configuration</h4>
                          <p>Submitted by Flow Jiang @2020-11-20 14:59</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-15" placement="top">
                        <el-card>
                          <h4>Fixed the bug of reimbursement remind</h4>
                          <p>Submitted by Flow Jiang @2020-11-15 21:09</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-14" placement="top">
                        <el-card>
                          <h4>Communication Tunnel optmization</h4>
                          <p>Submitted by Flow Jiang @2020-11-14 13:10</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-04" placement="top">
                        <el-card>
                          <h4>IT Service Request</h4>
                          <p>Submitted by Flow Jiang @2020-11-04 23:10</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-11-01" placement="top">
                        <el-card>
                          <h4>System Compliance Report</h4>
                          <p>Submitted by Steven Cui @2020-11-01 16:22</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-30" placement="top">
                        <el-card>
                          <h4>fixed the bug of x ratio of intern</h4>
                          <p>Submitted by Steven Cui @2020-10-30 15:59</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-30" placement="top">
                        <el-card>
                          <h4>new offer wechat congratulations</h4>
                          <p>Submitted by Steven Cui @2020-10-30 10:38</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-29" placement="top">
                        <el-card>
                          <h4>Remind emails</h4>
                          <p>Submitted by Flow Jiang @2020-10-29 21:38</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-28" placement="top">
                        <el-card>
                          <h4>real rolling bonus</h4>
                          <p>Submitted by Steven Cui @2020-10-28 22:08</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-27" placement="top">
                        <el-card>
                          <h4>Offer: fixed verify contract bug/ Bonus calc: fix commission rate bug</h4>
                          <p>Submitted by Steven Cui @2020-10-27 18:32</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-26" placement="top">
                        <el-card>
                          <h4>Offer report, quota by fiscal year, completion rate by the fiscal year</h4>
                          <p>Submitted by Steven Cui @2020-10-26 19:55</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-23" placement="top">
                        <el-card>
                          <h4>Revised remaining bonus cal</h4>
                          <p>Submitted by Flow Jiang @2020-10-23 09:31</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-22" placement="top">
                        <el-card>
                          <h4>Revised cost cal</h4>
                          <p>Submitted by Flow Jiang @2020-10-22 15:30</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-21" placement="top">
                        <el-card>
                          <h4>Task will be closed automatically</h4>
                          <p>Submitted by Flow Jiang @2020-10-21 22:47</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-17" placement="top">
                        <el-card>
                          <h4>Change account rules which connected to starlinks but without valid email address, from 10-01, for special cases</h4>
                          <p>Submitted by Flow Jiang @2020-10-17 17:21</p>
                        </el-card>
                      </el-timeline-item>
                        <el-timeline-item timestamp="2020-10-13" placement="top">
                        <el-card>
                          <h4>All leave records</h4>
                          <p>Submitted by Flow Jiang @2020-10-13 16:07</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-12" placement="top">
                        <el-card>
                          <h4>Fixed the bug of deleting leave records</h4>
                          <p>Submitted by Flow Jiang @2020-10-12 22:13</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-09" placement="top">
                        <el-card>
                          <h4>Bonus calculation v3</h4>
                          <p>Submitted by Flow Jiang @2020-10-09 21:49</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-10-09" placement="top">
                        <el-card>
                          <h4>Salary sheets bug fixing</h4>
                          <p>Submitted by Flow Jiang @2020-10-09 21:49</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-23" placement="top">
                        <el-card>
                          <h4>Account manager application form v2</h4>
                          <p>Submitted by Steven Cui @2020-09-23 20:10</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-23" placement="top">
                        <el-card>
                          <h4>Album</h4>
                          <p>Submitted by Flow Jiang @2020-09-23 18:22</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-21" placement="top">
                        <el-card>
                          <h4>Version update notification</h4>
                          <p>Submitted by Flow Jiang @2020-09-21 16:22</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-21" placement="top">
                        <el-card>
                          <h4>Account Manager application form</h4>
                          <p>Submitted by Steven Cui @2020-09-21 12:01</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-14" placement="top">
                        <el-card>
                          <h4>Account Manager</h4>
                          <p>Submitted by Steven Cui @2020-09-14 17:39</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-11" placement="top">
                        <el-card>
                          <h4>Birthday blessing</h4>
                          <p>Submitted by Flow Jiang @2020-09-11 17:22</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-10" placement="top">
                        <el-card>
                          <h4>Meeting room booking remind/calendar/attendees</h4>
                          <p>Submitted by Steven Cui @2020-09-10 16:17</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-08" placement="top">
                        <el-card>
                          <h4>Apply for account manager</h4>
                          <p>Submitted by Flow Jiang @2020-09-08 10:21</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-05" placement="top">
                        <el-card>
                          <h4>Signature pad for reimbursement</h4>
                          <p>Submitted by Flow Jiang @2020-09-05 12:46</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-09-02" placement="top">
                        <el-card>
                          <h4>Salary Records for Fiancial Report</h4>
                          <p>Submitted by Flow Jiang @2020-09-02 09:46</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-31" placement="top">
                        <el-card>
                          <h4>Word version payment notice downloading</h4>
                          <p>Submitted by Steven Cui @2020-08-31 14:21</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-29" placement="top">
                        <el-card>
                          <h4>Customizing payment notice template</h4>
                          <p>Submitted by Flow Jiang @2020-08-29 11:16</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-26" placement="top">
                        <el-card>
                          <h4>Filter username in absence report</h4>
                          <p>Submitted by Flow Jiang @2020-08-26 17:41</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-26" placement="top">
                        <el-card>
                          <h4>Total sum and remaining annual leave diaplyed in absence report</h4>
                          <p>Submitted by Steven Cui @2020-08-26 18:04</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-26" placement="top">
                        <el-card>
                          <h4>Check offer marketing solgan when apply invoice</h4>
                          <p>Submitted by Steven Cui @2020-08-26 19:01</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-25" placement="top">
                        <el-card>
                          <h4>Rivised bugs when users have probation or last period remaining days</h4>
                          <p>Submitted by Steven Cui @2020-08-25 11:39</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-21" placement="top">
                        <el-card>
                          <h4>Candidate report request</h4>
                          <p>Submitted by Tyler Liu @2020-08-21 19:59</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-19" placement="top">
                        <el-card>
                          <h4>User behavior spot checking</h4>
                          <p>Submitted by Flow Jiang @2020-08-19 19:59</p>
                        </el-card>
                      </el-timeline-item>
                      <el-timeline-item timestamp="2020-08-17" placement="top">
                        <el-card>
                          <h4>Recurring meeting</h4>
                          <p>Submitted by Steven Cui @2020-08-17 13:57</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('settings.config.title')" name="5">
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.contract') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73220" />
                      </div>
                      <h5 class="ct-title">
                        Steven Cui
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.am') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73220" />
                      </div>
                      <h5 class="ct-title">
                        Steven Cui
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.marketing') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73220" />
                      </div>
                      <h5 class="ct-title">
                        Steven Cui
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.contract-admin') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73232" />
                      </div>
                      <h5 class="ct-title">
                        Yina Dai
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.invoice') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73232" />
                      </div>
                      <h5 class="ct-title">
                        Yina Dai
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.report') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73232" />
                      </div>
                      <h5 class="ct-title">
                        Yina Dai
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.sales-support') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="324344" />
                      </div>
                      <h5 class="ct-title">
                        Yell Jiang
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.admin') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73232" />
                      </div>
                      <h5 class="ct-title">
                        Yina Dai
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.it') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="324344" />
                      </div>
                      <h5 class="ct-title">
                        Yell Jiang
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.new-staff') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73233" />
                      </div>
                      <h5 class="ct-title">
                        Yoga Qian
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.hr') }}
                    </el-col>
                    <el-col :span="6">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="471687" />
                      </div>
                      <h5 class="ct-title">
                        Echo He
                      </h5>
                    </el-col>
                    <el-col :span="6">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="478668" />
                      </div>
                      <h5 class="ct-title">
                        Rabbie Fang
                      </h5>
                    </el-col>
                    <el-col :span="6">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="482875" />
                      </div>
                      <h5 class="ct-title">
                        Elaine Zhao
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.ceo') }}
                    </el-col>
                    <el-col :span="18">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73220" />
                      </div>
                      <h5 class="ct-title">
                        Steven Cui
                      </h5>
                    </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                      {{ $t('settings.config.partners') }}
                    </el-col>
                    <el-col :span="6">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73220" />
                      </div>
                      <h5 class="ct-title">
                        Steven Cui
                      </h5>
                    </el-col>
                    <el-col :span="6">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73188" />
                      </div>
                      <h5 class="ct-title">
                        Cynthia Yang
                      </h5>
                    </el-col>
                    <el-col :span="6">
                      <div class="sm-avater list-avater">
                      <Avatar :userId="73229" />
                      </div>
                      <h5 class="ct-title">
                        Tyler Liu
                      </h5>
                    </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('settings.kpi.title')" name="6" v-if="userRole == 1">
                    <KPIConfiguration />
                  </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .edit_container {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 20px;
    }
    .ql-editor{
       height:300px;
    }
  .ql-snow .ql-editor img {
    max-width: 480px;
  }
  .ql-editor .ql-video {
    max-width: 480px;
  }
  .ct-title {
    text-overflow: none;
    overflow: none;
    max-width: none;
  }
</style>
<script>
import Avatar from '@/components/profile/Avatar.vue'
import KPIConfiguration from '@/components/common/KPIConfiguration.vue'

import Cookie from 'js-cookie'
import moment from 'moment'

export default {
  name: 'SettingsForm',
  components: {
    Avatar,
    KPIConfiguration
  },
  computed: {
    userRole: function() {
      return localStorage.getItem('role')
    }
  },
  data: function() {
  return {
    formData: {
        'lang': true,
        'offer': true,
        'cashin': true,
        'invoice': true,
        'task': true,
        'onboard': true,
        'email': true,
        'sync': true,
        'emailPass': null,
        'signature': null,
        'allowSend': true,
        'allowRead': true,
        'allowMeeting': true,
        'keepCopy': true
      },
      formRules: {

      },
      activeName: "1",
      'info': {
        'year': moment().year()
      },
      log: []
  }
  },
  watch: {
    "formData.lang": function() {
      if (this.formData.lang)
        this.$i18n.locale = 'en'
      else
        this.$i18n.locale = 'zh'
      Cookie.set('lang', this.$i18n.locale)
    }
  },
  methods: {
    onEditorReady: function(editor) {
    }
  },
  created: function() {
    this.formData.lang = this.$i18n.locale === 'en'
  }
}
</script>